export default __webpack_public_path__ + "static/media/KOD0074-min.f6e43467.webp";